const Header = () => {
    return (
        <>
            {/* header */}
            <header className={'container text-center'}>
                <div className="top-bar" style={{ paddingBottom: '15px' }}>
                    <div className="d-flex justify-content-center">
                        <img style={{ width: '300px', height: '130px' }} alt="logo" src={require('./../../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                    </div>
                    <p className="text-white text-center mb-5 mt-3 fw-bold">
                        سامانه ملی امن, سریع و آسان تراکنش ایران
                    </p>
                </div>
            </header>
        </>
    )
}

export default Header;